import defaultTranslations from './default.json';

export function translate(key: string) {
  const defaultValue: string =
    defaultTranslations[key as keyof typeof defaultTranslations] ?? key;
  if (import.meta.env.DEV) {
    return defaultValue;
  }
  if (typeof window.Drupal !== 'undefined') {
    return window.Drupal.t(defaultValue);
  }
  return defaultValue;
}
